const doc = [({"ja":({"draft":"下書き", "published":"配信予定", "processing":"処理中", "done":"完了"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;